import React from 'react';
import Script from 'react-load-script';

import BoxBody from 'components/BoxBody';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import Heading from 'components/Heading';
import Link from 'components/Link';
import Text from 'components/Text';
import CurrentUser from 'auth/CurrentUser';

const SNAPCALL_BID = 'f1393f303e0911eaac900dd3f449c992';

declare var window: {
  snapcallExtraContext: Function;
  snapcallAPI: {
    endCall: () => void;
    startCall: (bid: string) => void;
  };
};

type State = {
  loading: boolean;
};

export default class SupportCallButtonContainer extends React.Component<{}, State> {
  state: State = {
    loading: true,
  };

  componentDidMount() {
    const user = CurrentUser.isSignedIn() && CurrentUser.getUser();
    if (!user) {
      return;
    }

    // this sends down customer data so that the support team
    // knows who is calling
    window.snapcallExtraContext = function(callback: (data: { [key: string]: string }) => void) {
      callback({
        email: user.getEmail(),
        user_id: `${user.id}`,
      });
    };
  }

  componentWillUnmount() {
    window.snapcallAPI.endCall();
  }

  handleScriptError = () => {
    this.setState({ loading: false });
    console.error('SupportCallButtonContainer - SnapCall API failed to load');
  };

  handleScriptLoad = () => {
    this.setState({ loading: false }, () => window.snapcallAPI.startCall(SNAPCALL_BID));
  };

  render() {
    return (
      <BoxBody flush>
        {this.state.loading ? (
          <CenteredLoadingIndicator />
        ) : (
          <>
            <Heading>Calling...</Heading>
            <Text color="thunder">
              If you don't see your call starting, it may mean that there are no agents available or
              that you are calling outside of our phone support hours. Please email us at{' '}
              <Link href="http://rmd.me/help">rmd.me/help</Link> and we’ll give you a call back as
              soon as an agent is available.
            </Text>
          </>
        )}
        <Script
          url="https://snap.snapcall.io/snapapp.min.js"
          onError={this.handleScriptError}
          onLoad={this.handleScriptLoad}
          attributes={{ ['btn-bid']: SNAPCALL_BID }}
        />
      </BoxBody>
    );
  }
}
